import { Controller } from "@hotwired/stimulus"
import hljs from 'highlight.js/lib/core'
import json from 'highlight.js/lib/languages/json'

hljs.registerLanguage('json', json)

export default class extends Controller {
  static targets = ["code"]

  initialize() {
    this.handleThemeChange = this.handleThemeChange.bind(this)
  }

  connect() {
    this._applyTheme()
    hljs.highlightElement(this.codeTarget)
    document.addEventListener('theme-switcher:changed', this.handleThemeChange)
  }

  disconnect() {
    document.removeEventListener('theme-switcher:changed', this.handleThemeChange)
  }

  handleThemeChange() {
    this._applyTheme()
  }

  _applyTheme() {
    const isDark = document.documentElement.classList.contains('dark')
    this.element.classList.toggle('hljs-dark', isDark)
  }
}
